<template>
    <div>
        <div class="filter-container">
            <div class="left-content">
                <b-dropdown class="filter-dropdown" variant="default" ref="drop">
                    <template #button-content>
                        <span class="lc"><i class="icon icon-filter"></i>
                        Фильтр
                        </span><span class="rc"><i
                        class="icon icon-keyboard"></i></span>
                    </template>
                    <div>
                        <div class="top-content">
                            <span>Параметры фильтра</span>
                            <i class="icon icon-close" @click="$refs.drop.hide(true)"></i>
                        </div>
                        <!--------------- Плановый период ------------------->
                        <div class="filter-block">
                            <b-form-group label="Плановый период">
                                <multiselect
                                    ref="bcPlanYear"
                                    v-model="planPeriod"
                                    :options="planPeriodYears"
                                    placeholder="Выберите год"
                                    @close="loadVariantList">
                                </multiselect>
                            </b-form-group>
                        </div>
                        <!--------------- Регион ------------------->
                        <div class="filter-block">
                            <b-form-group label="Регион">
                                <multiselect
                                    ref="bcRegion"
                                    v-model="selectedReg"
                                    :options="regionList"
                                    track-by="code"
                                    label="text"
                                    :searchable="true"
                                    :allow-empty="false"
                                    :show-labels="false"
                                    placeholder="Выберите регион"
                                    @close="loadVariantList">
                                </multiselect>
                            </b-form-group>
                        </div>
                        <!--------------- Вид данных ------------------->
                        <div class="filter-block">
                            <b-form-group label="Вид данных">
                                <multiselect
                                    ref="bcDataType"
                                    v-model="dataType"
                                    :options="dataTypeList"
                                    track-by="code"
                                    label="text"
                                    placeholder="Выберите вид данных"
                                    @input="loadVariantByDataType">
                                </multiselect>
                            </b-form-group>
                        </div>
                        <!--------------- Версия бюджета ------------------->
                        <div class="filter-block">
                            <b-form-group label="Версия бюджета">
                                <multiselect
                                    ref="bcVariant"
                                    track-by="variant_uuid"
                                    label="name_ru"
                                    v-model="variant"
                                    :options="variantList"
                                    placeholder="Выберите версию бюджета"
                                    @close="getForecastReportingForm">
                                </multiselect>
                            </b-form-group>
                        </div>
                    </div>
                    <br>
                    <div v-if="currentView === 'pr6'"
                         class="filter-actions">
                        <b-button variant="primary" @click="applyButton">
                            Применить
                        </b-button>
                        <b-button variant="secondary" @click="resetButton">
                            Сбросить
                        </b-button>
                    </div>
                    <div v-if="currentView === 'note'"
                         class="filter-actions">
                        <b-button variant="primary" @click="applyButtonNote">
                            Применить
                        </b-button>
                        <b-button variant="secondary" @click="resetButton">
                            Сбросить
                        </b-button>
                    </div>
                </b-dropdown>
                <span v-if="currentView === 'pr6' && table_num === null" class="filter-title" style="margin-left: 15px">Приложение 6</span>
                <span v-if="currentView === 'pr6' && table_num !== null" class="filter-title" style="margin-left: 15px">{{ this.table_num + '  ' + this.table_name }}</span>
                <span v-if="currentView === 'pr8'" class="filter-title" style="margin-left: 15px">Приложение 8.ГЧП-МБ</span>
                <span v-if="currentView === 'pkfo1'" class="filter-title" style="margin-left: 15px">ПКФО-1МБ </span>
                <span v-if="currentView === 'pkfo2'" class="filter-title" style="margin-left: 15px">ПКФО-2МБ </span>
                <span v-if="currentView === 'pkfo3'" class="filter-title" style="margin-left: 15px">ПКФО-3МБ </span>
                <span v-if="currentView === 'pkfo4'" class="filter-title" style="margin-left: 15px">ПКФО-4МБ </span>
                <span v-if="currentView === 'pr7'" class="filter-title" style="margin-left: 15px">Приложение 7</span>
                <span v-if="currentView === 'pr9'" class="filter-title" style="margin-left: 15px">Приложение 9</span>
                <span v-if="currentView === 'note' && table_num === null" class="filter-title" style="margin-left: 15px">Пояснительная записка</span>
                <span v-if="currentView === 'note' && table_num !== null" class="filter-title" style="margin-left: 15px">{{ this.table_num + '  ' + this.table_name }}</span>
                <b-form-radio-group
                    style="margin-left: 15px"
                    v-if="currentView === 'pr8'"
                    id="radio-group-2"
                    v-model="year8"
                    @input="loadData8"
                    :options="formattedYears">
                </b-form-radio-group>
                <b-form-radio-group
                    style="margin-left: 15px"
                    v-if="currentView === 'pr7'"
                    id="radio-group-2"
                    v-model="year7"
                    @input="loadData7"
                    :options="formattedYears">
                </b-form-radio-group>
                <b-form-radio-group
                    style="margin-left: 15px"
                    v-if="currentView === 'pr9'"
                    id="radio-group-2"
                    v-model="year9"
                    @input="loadData9"
                    :options="formattedYears">
                </b-form-radio-group>
            </div>
            <div class="filter-actions" v-if="currentView !== 'list'">
                <b-button
                    v-if="actualVersion && (
                      (currentView === 'pr6' &&
                        (table_num === null ||
                         ['1.1', '1.3', '1.5', '1.12', '1.13', '1.14', '1.16'].includes(table_num))
                      ) ||
                      (currentView === 'note' &&
                        (table_num === null || noteTables.includes(table_num))
                      ) ||
                      !['pr6', 'note'].includes(currentView)
                    )"
                    variant="light" :disabled="isLoad"
                    @click="checkDataMethod">
                    Сверить данные
                </b-button>
                <b-button variant="light" @click="returnToList"><i
                    class="icon icon-keyboard icon-rotate-180"></i>
                    Назад к списку
                </b-button>
                <b-button v-if="actualVersion && table_num === '1.13'" :disabled="access_level === 1"
                          variant="success" @click="saveTable1_13">
                    Сохранить
                </b-button>
                <b-button v-if="actualVersion && table_num === '1.18'" :disabled="access_level === 1"
                          variant="success" @click="saveTable1_18">
                    Сохранить
                </b-button>
                <b-button v-if="actualVersion && table_num === '1.20'" :disabled="access_level === 1"
                          variant="success" @click="saveTable1_20">
                    Сохранить
                </b-button>
                <b-button v-if="actualVersion && table_num === '1.30'" :disabled="access_level === 1"
                          variant="success" @click="saveTable1_30">
                    Сохранить
                </b-button>
                <b-button v-if="actualVersion && (table_num === '1.22' || table_num === '1.23' || table_num === '1.24' ||
                                table_num === '1.25' || table_num === '1.26' || table_num === '1.27')"
                          :disabled="access_level === 1"
                          variant="success" @click="saveTableBalance">
                    Сохранить
                </b-button>
                <b-button v-if="actualVersion &&currentView === 'pr8'" :disabled="access_level === 1"
                          variant="success" @click="saveApp8">
                    Сохранить
                </b-button>
                <b-button v-if="actualVersion && currentView === 'pr7'" :disabled="access_level === 1"
                          variant="success" @click="saveApp7">
                    Сохранить
                </b-button>
                <b-button v-if="actualVersion && currentView === 'pr9'" :disabled="access_level === 1"
                          variant="success" @click="saveApp9">
                    Сохранить
                </b-button>
            </div>
            <div v-if="currentView === 'list'" class="filter-actions">
                <b-button variant="light" :disabled="isLoad" @click="checkDataMethod">
                    Сверить данные
                </b-button>
            </div>
        </div>
        <br><br>
        <b-progress variant="success" v-show="progress<100" height="10px" :value="progress" striped
                    animated></b-progress>
        <div v-if="currentView === 'list'">
            <div class="filter-breadcrumb">
                <span class="item-breadcrumb" v-if="planPeriod" @click="openFilterByRef('bcPlanYear')">
                  {{ planPeriod }}
                </span>
                <span class="item-breadcrumb" v-if="selectedReg" @click="openFilterByRef('bcRegion')">
                   {{ selectedReg.code }}
                </span>
                <span class="item-breadcrumb" v-if="dataType" @click="openFilterByRef('bcDataType')">
                   {{ dataType.text }}
                </span>
                <span class="item-breadcrumb" v-if="variant" @click="openFilterByRef('bcVariant')">
                   {{ variant.name_ru }}
                </span>
            </div>
            <div class="table-container fr-table">
                <b-table-simple striped hover bordered>
                    <b-thead>
                        <b-tr>
                            <b-th>Наименование формы</b-th>
                            <b-th>Дата изменений</b-th>
                            <b-th>Автор изменений</b-th>
                            <b-th>Примечание</b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="code in ['PR6', 'PR8', 'pkfo1', 'pkfo2', 'pkfo3', 'pkfo4', 'PR7', 'PR9', 'note']"
                              :key="code">
                            <b-td>
                                <div>
                                    <span class="title" @click="toggleShow(code)">{{ getTitle(code) }}</span>
                                    <span v-if="inCheckData && inCheckData.includes(code)"
                                          class="warning-icon"
                                          title="Внимание! Форма не соответствует контролю"> ⚠</span>
                                    <span class="subtitle">{{ getSubtitle(code) }}</span>
                                </div>
                            </b-td>
                            <template v-if="filteredFormList(code).length > 0">
                                <b-td v-for="(field, index) in filteredFormList(code)" :key="index">
                                    {{ formatDate(field.update_date) }}
                                </b-td>
                                <b-td v-for="(field, index) in filteredFormList(code)" :key="index + '-user'">
                                    {{ field.user_id_name }}
                                </b-td>
                            </template>
                            <template v-else>
                                <b-td></b-td>
                                <b-td></b-td>
                            </template>
                            <b-td>
                            <span class="modal-call" @click="openModal(code)">
                                <i v-if="filteredFormList(code).length > 0 && filteredFormList(code)[0].comments_text !== null"
                                   class="csi-icon csi-icon-chat"></i>
                                <i v-else
                                   :class="['icon', 'icon-plus-circle', { 'disabled-icon': !actualVersion }]"
                                   :style="{ opacity: actualVersion ? 1 : 0.5 }">
                                </i>
                            </span>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </div>
        </div>
        <div>
            <forecast-u-o-app6 v-if="currentView === 'pr6'"
                               ref="app6"
                               v-bind="forecastProps"
                               :show-inc="showPril6Inc"
                               :key="app6Key"
                               @open-inc="handleOpenInc"
                               @close-inc="showPril6Inc = false"
                               :checkDataList="getCheckData('PR6')"
            ></forecast-u-o-app6>
            <forecast-u-o-app8 v-if="currentView === 'pr8'"
                               ref="app8"
                               v-bind="forecastProps"
                               :checkDataList="getCheckData('PR8')"
            ></forecast-u-o-app8>
            <forecast-app6-tables
                v-if="currentView === 'pkfo1'"
                ref="pkfo1"
                v-bind="forecastProps"
                table_number="1.28"
                source="main"
                :checkDataList="getCheckData('pkfo1')"
            />
            <forecast-app6-tables
                v-if="currentView === 'pkfo2'"
                ref="pkfo2"
                v-bind="forecastProps"
                table_number="1.20"
                source="main"
                :checkDataList="getCheckData('pkfo2')"
            />
            <forecast-app6-tables
                v-if="currentView === 'pkfo3'"
                ref="pkfo3"
                v-bind="forecastProps"
                table_number="1.18"
                source="main"
                :checkDataList="getCheckData('pkfo3')"
            />
            <forecast-app6-tables
                v-if="currentView === 'pkfo4'"
                ref="pkfo4"
                v-bind="forecastProps"
                table_number="1.30"
                source="main"
                :checkDataList="getCheckData('pkfo4')"
            />
            <forecast-u-o-app7 v-if="currentView === 'pr7'"
                               ref="app7"
                               v-bind="forecastProps"
                               :checkDataList="getCheckData('PR7')"
            ></forecast-u-o-app7>
            <forecast-u-o-app9 v-if="currentView === 'pr9'"
                               ref="app9"
                               v-bind="forecastProps"
                               :checkDataList="getCheckData('PR9')"
            ></forecast-u-o-app9>
            <forecast-u-o-note v-if="currentView === 'note'"
                               ref="note"
                               v-bind="forecastProps"
                               :key="appNoteKey"
                               :show-inc="showNoteTabels"
                               @open-inc="handleOpenInc"
                               @open-table-note="handleOpenNote"
                               @close-inc="showNoteTabels = false"
                               :checkDataList="getCheckData('note')"
            ></forecast-u-o-note>
        </div>
        <b-modal v-model="showModal"
                 modal-class="fr-modal-comment"
                 title="Примечание:"
                 centered>
            <div class="comments-content">
                <div class="comments-content" v-if="filteredComments.length > 0">
                    <div class="comment-block" v-for="(comment, index) in filteredComments" :key="index">
                        <p class="label">
                            <span class="mr-1">{{ comment.comments_date }}</span>
                            <span>{{ comment.user_name }}</span></p>
                        <b-form-textarea v-model="comment.comments_text"
                                         @input="updateCommentText(comment.comments_text)"></b-form-textarea>
                    </div>
                </div>
                <div class="comments-content" v-else>
                    <div class="comment-block">
                        <p class="label"></p>
                        <b-form-textarea v-model="comments_text"></b-form-textarea>
                    </div>
                </div>
            </div>
            <template #modal-footer>
                <div class="modal-footer-content">
                    <div v-if="actualVersion && (access_level === 2 || access_level === 3)" class="buttons">
                        <b-button variant="light" @click="CancelComment">Отменить</b-button>
                        <b-button variant="success" @click="SaveComment">Сохранить</b-button>
                    </div>
                    <div class="comments-content" v-if="filteredComments.length > 0"
                         style="margin-right: 0; cursor: pointer;">
                        <div class="comment-block" v-for="(comment, index) in filteredComments" :key="index">
                            <p v-if="actualVersion && [2, 3].includes(access_level)"
                               class="label" @click="clearComment(comment)"><i class="icon icon-close"></i> ОЧИСТИТЬ</p>
                        </div>
                    </div>
                    <div class="comments-content" v-else style="margin-right: 0; cursor: pointer;">
                        <div class="comment-block">
                            <p v-if="actualVersion && [2, 3].includes(access_level)"
                               class="label" @click="clearComment(comments_text)"><i class="icon icon-close"></i>
                                ОЧИСТИТЬ</p>
                        </div>
                    </div>
                </div>
            </template>
        </b-modal>

        <b-modal v-model="showAddModal"
                 modal-class="fr-modal-comment"
                 title="Добавить примечание"
                 centered>
            <div class="comments-content">
                <div class="comment-block">
                    <b-form-group>
                        <b-form-textarea
                            id="textarea"
                            v-model="text"
                        ></b-form-textarea>
                    </b-form-group>
                </div>
            </div>
            <template #modal-footer>
                <div class="buttons">
                    <b-button variant="light" @click="showAddModal = false">Отменить</b-button>
                    <b-button variant="success">Сохранить</b-button>
                </div>
            </template>
        </b-modal>

        <b-modal v-model="modalConfirm"
                 modal-class="fr-modal-confirm"
                 title="Добавить примечание"
                 hide-footer
                 hide-header
                 size="sm"
                 centered>
            <span class="close-modal" @click="modalConfirm = false">
                <i class="icon icon-close"></i>
            </span>
            <div class="text">
                Импортировать данные
                из бюджетной заявки
                и плана финансирования?
            </div>
            <b-button variant="light" @click="modalConfirm = false">Нет</b-button>
            <b-button variant="success" @click="loadData('Yes')">Да</b-button>
        </b-modal>
        <b-modal v-if="isImport" v-model="modalConfirmUpdate"
                 modal-class="fr-modal-confirm"
                 hide-footer
                 hide-header
                 size="sm"
                 centered>
            <span class="close-modal" @click="modalConfirmUpdate = false">
                <i class="icon icon-close"></i>
            </span>
            <div class="text">При обновлении данных распределение сумм по статьям ПКФО удалится</div>
            <b-button variant="light" @click="modalConfirmUpdate = false">Отмена</b-button>
            <b-button variant="success" @click="loadData(selectedTable)">Ок</b-button>
        </b-modal>
    </div>
</template>

<script>
import store from "@/services/store";
import moment from "moment/moment";
import ForecastUOApp6 from "@/modules/forecast-reporting/ForecastUOApp6";
import ForecastUOApp8 from "@/modules/forecast-reporting/ForecastUOApp8";
import ForecastApp6Tables from "@/modules/forecast-reporting/ForecastApp6Tables";
import ForecastUOApp7 from "@/modules/forecast-reporting/ForecastUOApp7";
import ForecastUOApp9 from "@/modules/forecast-reporting/ForecastUOApp9";
import ForecastUONote from "@/modules/forecast-reporting/ForecastUONote";

export default {
    components: {ForecastUOApp6, ForecastUOApp8, ForecastApp6Tables, ForecastUOApp7, ForecastUOApp9, ForecastUONote},
    props: {
        access_level: Number
    },
    name: 'forecast-uo',
    data() {
        return {
            showModal: false,
            showAddModal: false,
            isLoad: false,
            isLoad7: false,
            text: null,
            obl: null,
            formList: [],
            codeForm: null,
            isImport: false,
            modalConfirm: false,
            modalConfirmUpdate: false,
            showPril6: false,
            currentView: 'list',
            showPril6Inc: false,
            showNoteTabels: false,
            planPeriod: null,
            selectedTable: null,
            planPeriodYears: [],
            selectedReg: null,
            regionList: [],
            dataType: null,
            actualVersion: false,
            actualVariantName: '',
            dataTypeList: [
                {text: 'Прогноз: Формирование бюджета', code: 1},
                {text: 'План: Утверждение бюджета', code: 2},
                {text: 'Уточнение бюджета', code: 3},
                {text: 'Корректировка бюджета', code: 4}
            ],
            year8: null,
            year7: null,
            year9: null,
            variant: null,
            variantList: [],
            table_name: '',
            table_num: null,
            abp: null,
            abpList: [],
            abp_list: [],
            comment: [],
            userName: null,
            filteredComments: [],
            comments_text: '',
            previousCommentText: [],
            app6Key: 0,
            appNoteKey: 0,
            showApp6: true,
            showAppNote: true,
            selectedRadio: 1,
            inCheckData: null,
            progress: 0,
            noteTables: Array.from({ length: 24 }, (_, i) => `${i + 1}.1`)
        }
    },
    async mounted() {
        await this.getMaxYear();
        await this.getObl();
    },
    computed: {
        filteredFormList() {
            return (code) => this.formList.filter(item => item.code_form === code);
        },
        formattedYears() {
            const year = parseInt(this.planPeriod.split(' - ')[0]);
            return [
                { value: year - 1, text: (year - 1).toString() },
                { value: year, text: year.toString() },
                { value: year + 1, text: (year + 1).toString() },
                { value: year + 2, text: (year + 2).toString() }
            ];
        },
        forecastProps() {
            if (
                !this.planPeriod ||
                !this.selectedReg ||
                !this.variant ||
                !this.dataType
            ) {
                return null;
            }
            return {
                year: parseInt(this.planPeriod.split(" - ")[0]),
                region: this.selectedReg.code,
                region_name: this.selectedReg.name_ru,
                version: this.variant.variant_uuid,
                version_name: this.variant.name_ru,
                dataType: this.dataType.code,
                obl: this.obl,
                actualVersion: this.actualVersion,
                radio_year: this[`year${this.currentView.replace('pr', '')}`] || null,
                access_level: this.access_level
            };
        }
    },
    watch: {
        planPeriod(newVal) {
            if (newVal) {
                const year = parseInt(newVal.split(' - ')[0]);
                this.year8 = year - 1;
                this.year7 = year - 1;
                this.year9 = year - 1;
            }
        },
        variant(newVal) {
            this.actualVersion = newVal && 'actual' in newVal;
        },
        forecastProps: {
            handler(val) {
                if (!val) return

                this.$emit('update-forecastuo-props', val)

            }
        }
    },
    methods: {
        getCheckData(formName) {
            if (!this.checkDataList) return [];

            return this.checkDataList.filter(item => {
                if (item.checked_form === formName) {
                    return true;
                }

                if (formName === 'note') {
                    return item.agreed_form?.startsWith('note');
                }
                else if (formName === 'PR6') {
                    return item.agreed_form?.startsWith('PR6');
                }

                return item.agreed_form === formName;
            });
        },
        handleOpenInc(tableNum, tableName) {
           this.showPril6Inc = true;
           this.table_num = tableNum;
           this.table_name = tableName;
        },
        handleOpenNote(tableNum, tableName) {
            this.showNoteTabels = true;
            this.table_num = tableNum;
            this.table_name = tableName;
        },
        formatDate(date) {
            if (date !== null){
                return new Date(date).toLocaleDateString('ru-RU', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                });
            }
        },
        toggleShow(code) {
            if (code === 'PR6') this.currentView = 'pr6';
            if (code === 'PR8') this.currentView = 'pr8';
            if (code === 'pkfo1') this.currentView = 'pkfo1';
            if (code === 'pkfo2') this.currentView = 'pkfo2';
            if (code === 'pkfo3') this.currentView = 'pkfo3';
            if (code === 'pkfo4') this.currentView = 'pkfo4';
            if (code === 'PR7') this.currentView = 'pr7';
            if (code === 'PR9') this.currentView = 'pr9';
            if (code === 'note') this.currentView = 'note';
            this.$emit('update-root-view', false);
        },
        getTitle(code) {
            if (code === 'PR6'){
                return 'Приложение 6';
            } else if (code === 'PR8'){
                return 'Приложение 8';
            } else if (code === 'pkfo1'){
                return 'ПКФО-1МБ';
            } else if (code === 'pkfo2'){
                return 'ПКФО-2МБ';
            } else if (code === 'pkfo3'){
                return 'ПКФО-3МБ';
            } else if (code === 'pkfo4'){
                return 'ПКФО-4МБ';
            } else if (code === 'PR7'){
                return 'Приложение 7';
            } else if (code === 'PR9'){
                return 'Приложение 9';
            } else if (code === 'note'){
                return 'Пояснительная записка';
            }
        },
        getSubtitle(code) {
            if (code === 'PR6'){
                return 'Перечень данных по структуре бюджета';
            } else if (code === 'PR8'){
                return 'Информация по государственным обязательствам по договорам государственно- частного партнерства, в том числе концессии';
            } else if (code === 'pkfo1'){
                return 'Прогнозный консолидированный отчет о финансовом положении';
            } else if (code === 'pkfo2'){
                return 'Прогнозный консолидированный отчет о результатах финансовой деятельности';
            } else if (code === 'pkfo3'){
                return 'Прогнозный консолидированный отчет о движении денег';
            } else if (code === 'pkfo4'){
                return 'Прогнозный консолидированный отчет об изменениях чистых активов/капитала';
            } else if (code === 'PR7'){
                return 'Информация по заимствованию местными исполнительными органами';
            } else if (code === 'PR9'){
                return 'Информация по бюджетным кредитам';
            } else if (code === 'note'){
                return 'Раскрытия к ПКФО-1 и ПКФО-2';
            }
        },
        showModalImport() {
            this.modalConfirm = this.actualVersion;
        },
        resetButton() {
            this.getMaxYear();
            this.getObl();
        },
        applyButton() {
            if (this.table_num === null) {
                this.$refs.app6?.getApp6Forms();
            }
            else {
                this.$refs.app6?.callTablesMethod();
            }
        },
        applyButtonNote() {
            if (this.table_num === null) {
                this.$refs.note?.getNoteForms();
            }
            else {
                this.$refs.note?.callTablesMethod();
            }
        },
        returnToList() {
            if (this.showPril6Inc) {
                this.showPril6Inc = false; // шаг назад к pr6
                this.table_num = null;
                this.$emit('update-root-view', false);
            }
            else if (this.showNoteTabels) {
                this.showNoteTabels = false; // шаг назад к списку ПЗ
                this.table_num = null;
                this.$emit('update-root-view', false);
            } else {
                this.currentView = 'list'; // шаг назад в список
                this.$emit('update-root-view', true);
            }
            this.getForecastReportingForm();
            this.showApp6 = false;
            this.showAppNote = false;
            this.$nextTick(() => {
                this.showApp6 = true;
                this.showAppNote = true;
                this.appNoteKey++;
                this.app6Key++;
            });
        },
        saveTable1_13() {
            this.$refs.app6?.callSaveMethod('1.13');
        },
        saveTable1_18() {
            this.$refs.app6?.callSaveMethod('1.18');
        },
        saveTable1_20() {
            this.$refs.app6?.callSaveMethod('1.20');
        },
        saveTable1_30() {
            this.$refs.app6?.callSaveMethod('1.30');
        },
        saveTableBalance() {
            this.$refs.app6?.callSaveMethod(this.table_num);
        },
        saveApp8() {
            this.$refs.app8.SaveData();
        },
        saveApp7() {
            this.$refs.app7.SaveData();
        },
        saveApp9() {
            this.$refs.app9.SaveData();
        },
        loadData8() {
            this.$refs.app8.getProjectList(this.year8);
        },
        loadData7() {
            this.$refs.app7.loadApp7(this.year7);
        },
        loadData9() {
            this.$refs.app9.loadApp9(this.year9);
        },
        openModal(code) {
            if (this.actualVersion || this.filteredFormList(code).length !== 0){
                this.comments_text = '';
                this.codeForm = code;
                this.filteredComments = this.formList.filter(comment => comment.code_form === code);

                if (this.filteredComments.length > 0) {
                    this.loadUserNames(this.filteredComments[0].comments_user_id, 'comment', code);
                }

                this.showModal = true;
            }
        },
        updateCommentText(newText) {
            this.comments_text = newText;
        },
        clearComment(comment){
            if (this.filteredComments.length > 0){
                comment.comments_text = '';
                this.comments_text = '';
            } else {
                this.comments_text = '';
            }
        },
        CancelComment(){
            this.showModal = false;
            this.getForecastReportingForm();
        },
        openFilterByRef(refName) {
            const drop = this.$refs.drop;
            drop.show(true);
            let refItem;
            switch (refName) {
                case 'bcPlanYear':
                    refItem = this.$refs.bcPlanYear;
                    break;
                case 'bcRegion':
                    refItem = this.$refs.bcRegion;
                    break;
                case 'bcVariant':
                    refItem = this.$refs.bcVariant;
                    break;
                case 'bcDataType':
                    refItem = this.$refs.bcDataType;
                    break;
                default:
                    break;
            }
            setTimeout(() => refItem.$el.focus(), 100);
        },
        async getMaxYear() {
            try {
                const response = await fetch('/api-py/get_max_year_from_budget_variant');
                if (response.status === 200) {
                    const yearNow = await response.json();
                    const years = [];

                    for (let i = yearNow; i >= 2022; i--) {
                        years.push(`${i} - ${i + 2}`);
                    }
                    this.planPeriodYears = years;
                    this.planPeriod = this.planPeriodYears[0];

                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса MaxYear', error.toString());
            }
        },
        async getObl() {
            try {
                await fetch('/api-py/get-budget-obl/' + store.state._instanceCode)
                    .then(response => response.json())
                    .then(json => {
                        this.obl = json.obl;
                        this.loadRegions();
                    });
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса getObl', error.toString());
            }
        },
        async loadRegions() {
            try {
                const response = await fetch('/api-py/get-user-regions-by-obl/' + this.obl + '/' + this.$store.getters.user_uuid);
                if (response.status === 200) {
                    this.regionList = await response.json();
                    this.selectedReg = this.regionList[0];
                    await this.loadVariantList();
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса регионов', error.toString());
            }
        },
        async SaveComment() {
            const checkComment = this.previousCommentText.filter(item => item.code === this.codeForm);
            if (checkComment.length === 0 || checkComment[0].comments_text !== this.filteredComments[0].comments_text){
                this.comment = [];
                const item = Object.assign({});
                this.$set(item, 'code_form', this.codeForm);
                this.$set(item, 'cur_year', parseInt(this.planPeriod.split(' - ')[0]));
                this.$set(item, 'region_code', this.selectedReg.code);
                this.$set(item, 'data_type', parseInt(this.dataType.code));
                this.$set(item, 'budget_variant', this.variant.variant_uuid);
                this.$set(item, 'comments_text', this.comments_text);
                this.$set(item, 'comments_date', moment().format('YYYY-MM-DD'));
                this.$set(item, 'comments_user_id', this.$store.getters.user_uuid);
                this.$set(item, 'pkfo_type', 'uo');
                this.isLoad = true;
                this.comment.push(item);
                try {
                    const response = await fetch('/api-py/add_comment_to_forecast_reporting_form', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8'
                        },
                        body: JSON.stringify(this.comment)
                    });
                    const result = await response.json();
                    if (response.status === 200 && result.result === 'success') {
                        this.showModal = false;
                        this.isSave = false;
                        this.makeToast('success', 'Сообщение', 'Примечание сохранено');
                        await this.getForecastReportingForm();
                        this.comments_text = '';
                    } else {
                        if (result.result === 'error') {
                            throw 'Ошибка сохранения данных.';
                        }
                    }
                } catch (e) {
                    this.makeToast('danger', 'Предупреждение', e.toString());
                } finally {
                    this.isLoad = false;
                }
            }
        },
        async getForecastReportingForm() {
            this.isLoad = true;
            this.previousCommentText = [];
            if (this.selectedReg !== null && this.dataType !== null && this.planPeriod !== null && this.variant !== null && this.variant !== undefined) {
                this.formList = [];
                this.curParams = {
                    cur_year: parseInt(this.planPeriod.split(' - ')[0]),
                    region: this.selectedReg.code,
                    variant: this.variant.variant_uuid,
                    pkfo_type: 'uo'
                }
                const response = await fetch(`/api-py/get_budget_forecast_reporting_form/` + JSON.stringify(this.curParams));
                const data = await response.json();
                this.formList = data.result;
                const formCodes = ['PR6', 'PR8', 'pkfo1', 'pkfo2', 'pkfo3', 'pkfo4', 'PR7', 'PR9'];
                for (const form_code of formCodes) {
                    const filteredList = this.formList.filter(item => item.code_form === form_code);
                    for (const item of filteredList) {
                        this.previousCommentText.push({
                            code: item.code_form,
                            comments_text: item.comments_text,
                        });
                        if (item.user_id !== null){
                            await this.loadUserNames(item.user_id, 'user_id', form_code);
                        }
                    }
                }
            }
            this.isLoad = false;
        },
        async loadUserNames(user_id, field, form_code) {
            const setName = (name) => {
                if (field === 'comment') {
                    this.filteredComments.forEach(comment =>
                        this.$set(comment, 'user_name', name)
                    );
                } else if (field === 'user_id') {
                    this.formList.forEach(code => {
                        if (code.code_form === form_code && code.user_id === user_id) {
                            this.$set(code, 'user_id_name', name);
                        }
                    });
                }
            };

            if (user_id === 'auto_user') {
                setName('auto_user');
                return;
            }
            try {
                const response = await fetch(`/api-py/get-realm-user/${user_id}`);
                if (response.ok) {
                    const { lastName, firstName } = await response.json();
                    setName(`${lastName} ${firstName}`);
                } else {
                    setName('');
                }
            } catch {
                setName('');
            }
        },
        async loadVariantList() {
            this.isLoad = true;
            if (this.selectedReg !== null && this.planPeriod !== null) {
                try {
                    const response = await fetch(`/api-py/get_budget_variant_for_forecast_reporting_form/` + this.selectedReg.code + '/' + parseInt(this.planPeriod.split(' - ')[0]));
                    const data = await response.json();
                    this.variantList = data.result;
                    this.variant = this.variantList[0];
                    if ('actual' in this.variant) {
                        this.actualVersion = true;
                        this.actualVariantName = this.variant.name_ru;
                    }
                    const matchedDataType = this.dataTypeList.find(item => item.code === this.variant.data_type);

                    if (matchedDataType) {
                        this.dataType = matchedDataType;
                    } else {
                        this.dataType = null;
                    }
                    await this.getForecastReportingForm();
                } catch (error) {
                    this.variant = null;
                    this.makeToast('danger', 'Ошибка', 'Версия бюджета не найдена');
                }
            }
            this.inCheckData = [];
            this.checkDataList = [];
            this.isLoad = false;
        },
        async loadVariantByDataType() {
            this.isLoad = true;
            if (this.selectedReg !== null && this.planPeriod !== null && this.dataType) {
                try {
                    const response = await fetch(`/api-py/get-variants-by-data-type/` + this.selectedReg.code + '/' + this.dataType.code + '/' + parseInt(this.planPeriod.split(' - ')[0]));
                    this.variantList = await response.json();
                    this.variantList.forEach((item) => {
                        if (item.is_deleted === false && item.attribute === true) {
                            item.name_ru += ' (акт.)';
                            item.actual = true;
                            this.variant = item;
                        } else {
                            this.variant = this.variantList[0];
                        }
                    });
                    await this.getForecastReportingForm();
                } catch (error) {
                    this.variant = null;
                    this.makeToast('danger', 'Ошибка', 'Версия бюджета не найдена');
                }
            }
            this.isLoad = false;
        },
        async checkDataMethod() {
            this.isLoad = true;
            this.progress = 15;
            if (this.selectedReg !== null && this.dataType !== null && this.planPeriod !== null && this.variant !== null
                && this.variant !== undefined) {
                this.checkDataList = [];
                this.progress = 45;
                const response = await fetch(`/api-py/check_data_for_uo_forecast_reporting/` + this.variant.variant_uuid + '/' + parseInt(this.planPeriod.split(' - ')[0]) + '/' + this.selectedReg.code + '/' + this.dataType.code);
                const data = await response.json();
                this.checkDataList = data.result;
                this.inCheckData = data.form_list;
                this.progress = 100;
                if (this.checkDataList.length === 0) {
                    this.makeToast('seccess', 'Внимание', 'Формы соответствуют контролю');
                } else {
                    this.makeToast('danger', 'Внимание', 'Формы не соответствуют контролю');
                }
            }
            this.isLoad = false;
        },

        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        },
    }
}
</script>

<style>
.modal-footer-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.comments-content {
    cursor: pointer;
    margin-right: 0;
}
.warning-icon {
    color: #f5a623; /* желтый */
    font-size: 16px;
    margin-right: 5px;
    cursor: pointer;
}

</style>